// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__lGiyC","options":"AnswerScale_options__3roBY","selected":"AnswerScale_selected__1noNP"};